import { styled, Slider } from '@mui/material';
const SizeSlider = styled(Slider)(({ theme }) => ({
    '&.MuiSlider': {
        '&-root': {
            padding: 0,
            paddingBottom: 15,
            color: theme.palette.primary.dark,
            '& .MuiSlider-markLabel': {
                top: 17,
                color: theme.palette.primary.dark,
                fontSize: '0.75rem',
            },
        },
    },
}));
export { SizeSlider };
